import React from "react";
import Header from "../../Header";
import "../../styles/theme.scss";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import AdminTab from "../../components/admin/AdminTab";
const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));
function AdminPage() {
  const navigate = (path) => {
    window.location.href = path;
  };
  const handleNavigation = (path) => {
    navigate(path);
  };
  const { t } = useTranslation();
  return (
    <Grid>
      <Header
        navigate={handleNavigation}
        children={
          <Content>
            <AdminTab />
          </Content>
        }
      />
    </Grid>
  );
}

export default AdminPage;
